import { render, staticRenderFns } from "./ClickableDropdown.vue?vue&type=template&id=ada4b9e2&"
import script from "./ClickableDropdown.vue?vue&type=script&lang=js&"
export * from "./ClickableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ClickableDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports